import { useMemo } from 'react'
import _get from 'lodash.get'

import { useEventFeedsContext } from '../pages/event-feeds/context/index.jsx'
import formatAmericanDashDate from '../lib/dateUtils.js'
import { TIME_PERIOD_VALUES } from '../components/period-select/index.jsx'
import { TYPES } from '../pages/event-feeds/visualization-panel/trends/index.jsx'
import { LOOKBACK_VALUES } from '../components/lookback-select/index.jsx'
import { TYPE_PREBUILT_ATTRIBUTES_V2 } from '../pages/event-feeds/wizard/index.jsx'
import { TIME_INTERVAL_VALUES } from '../components/interval-select/index.jsx'

const past6Months = new Date()
past6Months.setMonth(past6Months.getMonth() - 6)

const past30Days = new Date()
past30Days.setDate(past30Days.getDate() - 30)

const DEFAULT_START_DATE = formatAmericanDashDate(past6Months)
const DEFAULT_END_DATE = formatAmericanDashDate(new Date())
const DEFAULT_INTERVAL = 'weekly'
const DEFAULT_SCALE = 'normal'
const DEFAULT_PERIOD = 6
const DEFAULT_FIELD = TYPES.ENTITIES
const DEFAULT_TERMS = []
const DEFAULT_LOOKBACK = LOOKBACK_VALUES.WEEK_1

export default function useRequestConfig(visualizationDataPath, defaultsOverrides = {}) {
  const { data, id } = useEventFeedsContext()
  const visualizations = data?.visualizations

  const v = _get(visualizations, visualizationDataPath) || {}

  const start = v?.start || defaultsOverrides.start || DEFAULT_START_DATE
  const end = v?.end || defaultsOverrides.end || DEFAULT_END_DATE
  const interval = v?.interval || defaultsOverrides.interval || DEFAULT_INTERVAL
  const period = v?.period || defaultsOverrides.period || DEFAULT_PERIOD
  const scale = v?.scale || defaultsOverrides.scale || DEFAULT_SCALE
  const field = v?.field || defaultsOverrides.field || DEFAULT_FIELD
  const terms = v?.terms || defaultsOverrides.terms || DEFAULT_TERMS
  const lookback = v?.lookback || defaultsOverrides.lookback || DEFAULT_LOOKBACK

  const dynamicStart = useMemo(() => {
    const newDate = new Date()
    newDate.setMonth(newDate.getMonth() - period)
    return formatAmericanDashDate(newDate)
  }, [period])

  const requestConfig = useMemo(() => {
    return data._id || id === 'discovery'
      ? {
          ...data,
          start: period === TIME_PERIOD_VALUES.CUSTOM ? start : dynamicStart,
          end: period === TIME_PERIOD_VALUES.CUSTOM ? end : formatAmericanDashDate(new Date()),
          interval,
          period,
          scale,
          field,
          terms,
          lookback,
        }
      : {}
  }, [data, dynamicStart, interval, period, field, terms, lookback])

  if (visualizationDataPath === TYPE_PREBUILT_ATTRIBUTES_V2) {
    return {
      interval: TIME_INTERVAL_VALUES.DAILY,
      start: formatAmericanDashDate(past30Days),
      end: formatAmericanDashDate(new Date()),
    }
  }
  return requestConfig
}
